import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { usePageView } from '@fs/zion-analytics'
import { Cell, Grid, Expander, ExpanderContent, ExpanderHeader, H5 } from '@fs/zion-ui'
import { usePageTitle } from '../../../app/PageTitleContext'
import { useDatsJobs } from './useDatsJobs'
import { DatsJobsTable } from './DatsJobsTable'
import { RawData } from '../../../common/RawData'
import CreateJob from './createJob/CreateJob'
import { DatsJobsFilters } from './DatsJobsFilters'

export default function DatsJobs() {
  usePageView({ page_detail: 'DMConsole:DatsJobs' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.tools.distributedJobs'))
  const { datsJobsState, datsJobsFunctions } = useDatsJobs()
  const [open, setOpen] = useState(true)

  useEffect(() => {
    datsJobsFunctions.getTableFiltered()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datsJobsState.currentUser.cisId, datsJobsState.clearFiltersToggle])

  return (
    <Grid>
      {/* Row */}
      <Cell columns={12}>
        <CreateJob refreshJobs={datsJobsFunctions.getTableFiltered} />
      </Cell>
      <Cell columns={12}>
        <Expander open={open} setOpen={setOpen} ariaControlsId="filters_expander">
          <ExpanderHeader>
            <H5>Filters</H5>
          </ExpanderHeader>
          <ExpanderContent>
            <DatsJobsFilters datsJobsState={datsJobsState} datsJobsFunctions={datsJobsFunctions} setOpen={setOpen} />
          </ExpanderContent>
        </Expander>
      </Cell>
      {/* Row */}
      <Cell columns={12}>
        <RawData state={datsJobsState} />
      </Cell>
      {/* Row */}
      <Cell columns={12}>
        <DatsJobsTable datsJobsState={datsJobsState} datsJobsFunctions={datsJobsFunctions} />
      </Cell>
    </Grid>
  )
}
